export const SET_IS_LOADING = 'SET_IS_LOADING';
export const setIsLoading = (loadingState) => ({
    type: SET_IS_LOADING,
    payload: loadingState,
});
